let isHandlingClick = false;

const preventDoubleClick = async (handler) => {
  if (isHandlingClick) {
    return;
  }

  isHandlingClick = true;

  try {
    await handler();
  } finally {
    isHandlingClick = false;
  }
};

export const resetPreventDoubleClick = () => {
  isHandlingClick = false;
};

export default preventDoubleClick;
